<template>
    <auth-layout>
        <template #topLink>
            <v-btn v-if="!isIosApp" text color="txtSecondary" class="text-none" :to="{name: 'register'}">
                {{ $t('entrance.create_user') }}
            </v-btn>
        </template>
        <login @success="onLoginSuccess" />
    </auth-layout>
</template>

<script>

import AuthLayout from '@/components/entrance/AuthLayout'
import Login from '@/components/entrance/Login'

import {mapState} from 'vuex'

export default {
    components: {
        AuthLayout,
        Login
    },
    computed: {
        ...mapState(['account', 'loadingUser']),
    },
    methods: {
        onLoginSuccess(loaded = false) {
            const vm = this
            if (loaded) {
                if (!vm.currentUser) return
                if (!vm.currentUser.emailVerified) return vm.$router.replace({name: 'confirm-mail'})
                if (!vm.account?.accountType) return vm.$router.replace({name: 'select-profile'})
                if (vm.account.accountType === 'coach_company') {
                    return vm.account.firstLogin === true ?
                        vm.$router.replace({name: 'coach-company-invitation'}) :
                        vm.$router.push({name: 'coach.home'})
                }
                if (!vm.account?.name) return vm.$router.replace({name: 'basic-info'})
                return vm.$router.push({name: `${vm.accountType}.home`})
            }
        },
    },
    watch: {
        loadingUser(isLoading) {
            if (!isLoading) {
                var vm = this
                vm.onLoginSuccess(true)
            }
        }
    }
}
</script>
